var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1194.4552,
    height: 1194.3184,
    id: "svg551",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs511"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2625,
    y: 319,
    width: 1601,
    height: 1461,
    id: "rect484"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect487"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect490"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect493"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect496"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect499"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1598,
    height: 1459,
    id: "rect502"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1599,
    height: 1460,
    id: "rect505"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2626,
    y: 319,
    width: 1599,
    height: 1460,
    id: "rect508"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    id: "g517",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3425.47,461.305 c 254.73,0 480.49,164.027 559.21,406.292 L 3425.47,1049.3 Z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ff8310",
    fillRule: "evenodd",
    id: "path515"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    id: "g521",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3984.68,867.597 c 100.35,308.843 -68.67,640.563 -377.51,740.913 -58.68,19.07 -120,28.78 -181.7,28.78 V 1049.3 Z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#27cbef",
    fillRule: "evenodd",
    id: "path519"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    id: "g525",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3425.47,1637.29 c -254.73,0 -480.5,-164.03 -559.21,-406.29 l 559.21,-181.7 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#895ef3",
    fillRule: "evenodd",
    id: "path523"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    id: "g529",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2866.26,1231 c -38.38,-118.1 -38.38,-245.308 0,-363.402 l 559.21,181.702 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#acdf35",
    fillRule: "evenodd",
    id: "path527"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    id: "g533",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2866.26,867.597 c 38.37,-118.094 113.14,-221.01 213.6,-293.996 l 345.61,475.699 z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#6b97d8",
    fillRule: "evenodd",
    id: "path531"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    id: "g537",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3079.86,573.601 C 3180.31,500.615 3301.3,461.305 3425.47,461.305 V 1049.3 Z",
    stroke: "#ffffff",
    strokeWidth: 18.3333,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#00d89e",
    fillRule: "evenodd",
    id: "path535"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    id: "g543",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3183,1041.5 c 0,-131.168 106.11,-237.5 237,-237.5 130.89,0 237,106.332 237,237.5 0,131.17 -106.11,237.5 -237,237.5 -130.89,0 -237,-106.33 -237,-237.5 z",
    fill: "#ffffff",
    fillRule: "evenodd",
    id: "path541"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    id: "g547",
    transform: "translate(-2828.3087,-452.13835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3239,1044 c 0,-99.411 80.59,-180 180,-180 99.41,0 180,80.589 180,180 0,99.41 -80.59,180 -180,180 -99.41,0 -180,-80.59 -180,-180 z",
    fill: "#d3e9e6",
    fillRule: "evenodd",
    id: "path545"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocation);
export default __webpack_public_path__ + "static/media/allocation.b44b2b40ef8a2896f814a66d49e5fab0.svg";
export { ForwardRef as ReactComponent };